import {
    type Plane,
    type FireCell,
    FrontAgent,
    type Coordinate
} from '@firesim/simkit-core';
import { TerrainCodes, terrain, terrainTypes } from "./terrain-types";
const protectedTerrain = [TerrainCodes.House, TerrainCodes.PukimaniPoles];

/**
    * Place an ignition at the provided coordinates
    * @param {object} coords The coordinates to centre the ignition at
    * @param {number} coords.x The x coordinate to centre the ignition at
    * @param {number} coords.y The y coordinate to centre the ignition at
    * @return {undefined} no return value
    **/
export function placeIgnitionAt(coords: Coordinate, plane: Plane<TerrainCodes, FireCell<TerrainCodes>>): void {
    const x = coords.x;
    const y = coords.y;

    const colour = {
        red: 226,
        green: 6,
        blue: 5,
        alpha: 255
    };
    const layer = 'fire';

    let ignitionPoint = plane.getCell(x, y);
    if(!ignitionPoint) {
        throw new Error(`Invalid ignition coordinate ${x},${y}`);
    }

    if(!ignitionPoint.agents.length) {
        let ignition = new FrontAgent<TerrainCodes>(plane, {terrainTypes, protectedTerrain});
        plane.addAgentToCell(ignition, ignitionPoint);
        plane.drawCell(x, y, colour.red, colour.green, colour.blue, colour.alpha, {layer});
    }

    ignitionPoint = plane.getCell(x - 1, y);
    if(ignitionPoint && !ignitionPoint.agents.length) {
        let ignition = new FrontAgent(plane, {terrainTypes, protectedTerrain});
        plane.addAgentToCell(ignition, ignitionPoint);
        plane.drawCell(x - 1, y, colour.red, colour.green, colour.blue, colour.alpha, {layer});
    }

    ignitionPoint = plane.getCell(x + 1, y);
    if(ignitionPoint && !ignitionPoint.agents.length) {
        let ignition = new FrontAgent(plane, {terrainTypes, protectedTerrain});
        plane.addAgentToCell(ignition, ignitionPoint);
        plane.drawCell(x + 1, y, colour.red, colour.green, colour.blue, colour.alpha, {layer});
    }

    ignitionPoint = plane.getCell(x, y - 1);
    if(ignitionPoint && !ignitionPoint.agents.length) {
        let ignition = new FrontAgent(plane, {terrainTypes, protectedTerrain});
        plane.addAgentToCell(ignition, ignitionPoint);
        plane.drawCell(x, y - 1, colour.red, colour.green, colour.blue, colour.alpha, {layer});
    }

    ignitionPoint = plane.getCell(x, y + 1);
    if(ignitionPoint && !ignitionPoint.agents.length) {
        let ignition = new FrontAgent(plane, {terrainTypes, protectedTerrain});
        plane.addAgentToCell(ignition, ignitionPoint);
        plane.drawCell(x, y + 1, colour.red, colour.green, colour.blue, colour.alpha, {layer});
    }
}


